import gql from 'graphql-tag';

const CheckDocuments = gql`
  mutation CheckDocuments($input: CheckDocumentsMutationInput!) {
    checkDocuments(input: $input) {
      task {
        id
        claim {
          id
          codeClaim
          reason
          token
          createdAt
          updatedAt
          totalDelay
          flightId
          crmState
          passengerTicketId
          maximumCompensationAmount
          correctedInformation
          travelerFormUrl
          refundFromAirlineAmount
          refundFromAirlineDate
          refundToPaxAmount
          refundToPaxDate
          passengerTicket {
            id
            pnr
            number
            passengerFirstName
            passengerLastName
            passengerPhone
            passengerEmail
            passengerLanguage
            employer
            profession
            gender
            nationality
            dateOfBirth
            street
            city
            postCode
            country
            bankInformation
            affiliate {
              id
              name
            }
          }
          flight {
            id
            number
            localDepartureDate
            localArrivalDate
            airlineCode
            airline {
              name
              iata
            }
            airportOrigin {
              name
              iata
            }
            airportDestination {
              name
              iata
            }
          }
          affiliate {
            id
            name
          }
          claimsPassengerTicketConnection {
            edges {
              node {
                claimId
                promoCode {
                  id
                  code
                  percentage
                }
                passengerTicketId
                documentsConnection {
                  edges {
                    cursor
                    node {
                      documentId
                      id
                      attachmentContentType
                      documentUrl
                      status
                      conflictsWithClaim
                      formAttributes
                      claimsPassengerTicket {
                        id
                        passengerTicket {
                          id
                          passengerFirstName
                          passengerLastName
                        }
                      }
                      type
                    }
                  }
                }
                loa {
                  id
                  loaConsent
                  tcConsent
                  visaConsent
                  adult
                  guardianFullName
                  visaCard
                  myclaimUrl
                  signedLoaDocumentUrl
                }
                passengerTicket {
                  id
                  pnr
                  number
                  passengerFirstName
                  passengerLastName
                  passengerPhone
                  passengerEmail
                  passengerLanguage
                  employer
                  profession
                  gender
                  nationality
                  dateOfBirth
                  street
                  city
                  postCode
                  country
                  bankInformation
                  affiliate {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export { CheckDocuments };



// WEBPACK FOOTER //
// ./src/mutations/CheckDocuments.js